export default __webpack_public_path__ + "static/media/members-icon.67d63796.svg";